import { RootState } from 'store/rootReducer';
import { getSimpleDataSelector } from '@cp-shared-19/frontend-integration';
import { CustomerType } from 'cpes-common';

export const CustomerTypeDataSelector = (state: RootState) => state.customerType;

export const CustomerTypeSelector = getSimpleDataSelector(CustomerTypeDataSelector);

export function setDefaultCustomerType(customerType?: CustomerType): CustomerType {
    return customerType ?? 'PRIVATE';
}
